import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import {
    ADD_CONFIG_ROW,
    APP_LEAVING,
    CHANGE_CONFIG_ROW,
    CHANGE_CUSTOM_CONTENT_LANGUAGE_CODE,
    CHANGE_FIELDS,
    DELETE_CONFIG_ROW,
    EDIT_CONFIG_ROW,
    MAKE_INVISIBLE_FILTERS,
    MAKE_VISIBLE_FILTERS,
    SET_ARRAY_OR_OBJECT_IN_CONFIG,
    SET_BOOLEAN_VALUE_IN_CONFIG,
    SET_CUSTOM_CONTENT_TEXT_VALUE_IN_CONFIG,
    SET_NUMBER_VALUE_IN_CONFIG,
    SET_TEXT_VALUE_IN_CONFIG,
    TOGGLE_BOOLEAN_VALUE_IN_CONFIG,
    UNSET_VALUE_IN_CONFIG,
    SET_LIST_VALUE_IN_CONFIG
} from '../../constants/ActionTypes';
import ConfirmationConfiguration from '../pages/pages/ConfirmationConfiguration';
import GlobalBarConfiguration from '../pages/pages/GlobalBarConfiguration';
import SearchSettingsConfigurations from '../pages/pages/SearchSettingsConfigurations';
import FilterConfiguration from '../pages/pages/FilterConfiguration';
import RoomsConfiguration from '../pages/pages/RoomsConfiguration';
import GeneralConfiguration from '../pages/pages/GeneralConfiguration';
import HotelConfiguration from '../pages/pages/HotelConfiguration';
import MenuContent from '../pages/pages/MenuContent';
import GuestConfiguration from '../pages/pages/GuestConfiguration';
import { checkPermissionForLevel, checkPermissions } from '../../../lib/utils';
import { ACCESS_POINTS_GROUP, ACCESS_POINT_LEVEL } from '../../constants/AccessPoints';
import RetailProductsConfiguration from 'components/pages/pages/retailProducts/RetailProductsConfiguration';
import { get } from 'lodash';

class ModalConfirmationSettings extends Component {
    static propTypes = {
        pageTitle: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.onClose = this.onClose.bind(this);
        this.state = {
            dummy: false
        };
    }

    onClose() {
        // this.props.changeCustomContentLanguageCode(this.props.defaultLanguageCode)
        this.props.close();
    }

    componentDidMount() {
        if (this.props.onIndex) {
            this.props.onIndex(ReactDOM.findDOMNode(this).innerText);
        }
    }

    returnDisplayItem() {
        const propsTemplate = {
            onIndex: this.props.onIndex,
            searchIndex: this.props.searchIndex,
            ref: node => (this.rootRef = node)
        };
        switch (this.props.component) {
            case 'guestInfo':
                return (
                    <GuestConfiguration
                        setConfigBoolean={this.props.setConfigBoolean}
                        toggleConfigBoolean={this.props.toggleConfigBoolean}
                        setConfigText={(code, value) => this.props.setConfigText(code, value)}
                        currentConfigCopy={this.props.currentConfigCopy}
                        location={this.props.location}
                        isDisabled={!this.props.hasAccessConfigurationEdit}
                        onIndex={this.props.onIndex}
                        searchIndex={this.props.searchIndex}
                        {...propsTemplate}
                    />
                );
            case 'confirmation':
                return (
                    <ConfirmationConfiguration
                        setConfigBoolean={this.props.setConfigBoolean}
                        toggleConfigBoolean={this.props.toggleConfigBoolean}
                        setConfigText={this.props.setConfigText}
                        currentConfigCopy={this.props.currentConfigCopy}
                        location={this.props.location}
                        isDisabled={!this.props.hasAccessConfigurationEdit}
                        onIndex={this.props.onIndex}
                        searchIndex={this.props.searchIndex}
                        {...propsTemplate}
                    />
                );
            case 'menuContent':
                return (
                    <MenuContent
                        changeCustomContentLanguageCode={this.props.changeCustomContentLanguageCode}
                        currentConfigCopy={this.props.currentConfigCopy}
                        defaultLanguageCode={this.props.defaultLanguageCode}
                        isDisabled={!this.props.hasAccessConfigurationEdit}
                        languageCode={this.props.languageCode}
                        languageList={this.props.languageList}
                        location={this.props.location}
                        saveHotelMenuContent={this.props.saveHotelMenuContent}
                        {...propsTemplate}
                    />
                );
            // previously named calendar
            case 'searchSettings':
                return (
                    <SearchSettingsConfigurations
                        setConfigBoolean={this.props.setConfigBoolean}
                        toggleConfigBoolean={this.props.toggleConfigBoolean}
                        setConfigText={this.props.setConfigText}
                        setConfigNumber={this.props.setConfigNumber}
                        currentConfigCopy={this.props.currentConfigCopy}
                        location={this.props.location}
                        isDisabled={!this.props.hasAccessConfigurationEdit}
                        searchIndex={this.props.searchIndex}
                        {...propsTemplate}
                    />
                );
            case 'globalBar':
                return (
                    <GlobalBarConfiguration
                        setConfigBoolean={this.props.setConfigBoolean}
                        toggleConfigBoolean={this.props.toggleConfigBoolean}
                        setConfigText={this.props.setConfigText}
                        currentConfigCopy={this.props.currentConfigCopy}
                        setCustomConfigText={this.props.setCustomConfigText}
                        addConfigRow={() => {
                            this.props.addConfigRow('loyaltyAssignments');
                        }}
                        deleteConfigRow={index => {
                            this.props.deleteConfigRow('loyaltyAssignments', index);
                        }}
                        editConfigRow={(editCode, index, value) => {
                            this.props.editConfigRow('loyaltyAssignments', editCode, index, value);
                        }}
                        location={this.props.location}
                        isDisabled={!this.props.hasAccessConfigurationEdit}
                        onIndex={this.props.onIndex}
                        searchIndex={this.props.searchIndex}
                        {...propsTemplate}
                    />
                );
            case 'filters':
                return (
                    <FilterConfiguration
                        setConfigBoolean={this.props.setConfigBoolean}
                        toggleConfigBoolean={this.props.toggleConfigBoolean}
                        setConfigText={(code, value) => this.props.setConfigText(code, value)}
                        currentConfigCopy={this.props.currentConfigCopy}
                        makeInvisibleFilters={this.props.makeInvisibleFilters}
                        makeVisibleFilters={this.props.makeVisibleFilters}
                        isDisabled={!this.props.hasAccessConfigurationEdit}
                        location={this.props.location}
                        ref={node => (this.rootRef = node)}
                        onIndex={this.props.onIndex}
                        searchIndex={this.props.searchIndex}
                        inContextBeta={this.props.inContextBeta}
                    />
                );
            case 'hotel':
                return (
                    <HotelConfiguration
                        setConfigBoolean={this.props.setConfigBoolean}
                        toggleConfigBoolean={this.props.toggleConfigBoolean}
                        setConfigText={this.props.setConfigText}
                        setConfigNumber={this.props.setConfigNumber}
                        currentConfigCopy={this.props.currentConfigCopy}
                        makeInvisibleFilters={this.props.makeInvisibleFilters}
                        makeVisibleFilters={this.props.makeVisibleFilters}
                        isDisabled={!this.props.hasAccessConfigurationEdit}
                        addConfigRow={this.props.addConfigRow}
                        changeConfigRow={this.props.changeConfigRow}
                        deleteConfigRow={this.props.deleteConfigRow}
                        editConfigRow={this.props.editConfigRow}
                        location={this.props.location}
                        onIndex={this.props.onIndex}
                        searchIndex={this.props.searchIndex}
                        {...propsTemplate}
                    />
                );
            case 'rooms':
                return (
                    <RoomsConfiguration
                        setConfigBoolean={this.props.setConfigBoolean}
                        toggleConfigBoolean={this.props.toggleConfigBoolean}
                        setConfigText={this.props.setConfigText}
                        setConfigNumber={this.props.setConfigNumber}
                        currentConfigCopy={this.props.currentConfigCopy}
                        addConfigRow={path => {
                            this.props.addConfigRow('videoPaths', path);
                        }}
                        isDisabled={!this.props.hasAccessConfigurationEdit}
                        deleteConfigRow={index => {
                            this.props.deleteConfigRow('videoPaths', index);
                        }}
                        editConfigRow={(editCode, index, value) => {
                            this.props.editConfigRow('videoPaths', editCode, index, value);
                        }}
                        location={this.props.location}
                        ref={node => (this.rootRef = node)}
                        onIndex={this.props.onIndex}
                        searchIndex={this.props.searchIndex}
                        inContextBeta={this.props.inContextBeta}
                    />
                );
            case 'general':
                return (
                    <GeneralConfiguration
                        setConfigBoolean={this.props.setConfigBoolean}
                        toggleConfigBoolean={this.props.toggleConfigBoolean}
                        unsetConfigValue={this.props.unsetConfigValue}
                        setConfigText={this.props.setCustomConfigText}
                        setConfigNumber={this.props.setConfigNumber}
                        currentConfigCopy={this.props.currentConfigCopy}
                        languageCode={this.props.languageCode}
                        isDisabled={!this.props.hasAccessConfigurationEdit}
                        defaultLanguageCode={this.props.defaultLanguageCode}
                        languageList={this.props.languageList}
                        changeCustomContentLanguageCode={this.props.changeCustomContentLanguageCode}
                        addConfigRow={() => {
                            this.props.addConfigRow('videoPaths');
                        }}
                        deleteConfigRow={index => {
                            this.props.deleteConfigRow('videoPaths', index);
                        }}
                        editConfigRow={(editCode, index, value) => {
                            this.props.editConfigRow('videoPaths', editCode, index, value);
                        }}
                        location={this.props.location}
                        ref={node => (this.rootRef = node)}
                        onIndex={this.props.onIndex}
                        searchIndex={this.props.searchIndex}
                    />
                );
            case 'retailProducts':
                return (
                    <RetailProductsConfiguration
                        currentConfigCopy={this.props.currentConfigCopy}
                        isDisabled={!this.props.hasAccessConfigurationEdit}
                        toggleConfigBoolean={this.props.toggleConfigBoolean}
                        retailProductCategories={this.props.retailProductCategories}
                        setListInConfig={this.props.setListInConfig}
                        setArrayOrObjectInConfig={this.props.setArrayOrObjectInConfig}
                        saveState={this.props.saveState}
                        currentConfig={this.props.currentConfig}
                    />
                );
        }
        return null;
    }

    render() {
        if (this.props.pageTitle) {
            return (
                <section>
                    <h2>{this.props.pageTitle}</h2>
                    {this.returnDisplayItem()}
                </section>
            );
        }
        return this.returnDisplayItem();
    }
}

ModalConfirmationSettings.defaultProps = {
    open: false
};

ModalConfirmationSettings.propTypes = {
    open: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    retailProductCategories: PropTypes.array,
    setListInConfig: PropTypes.func,
    setArrayOrObjectInConfig: PropTypes.func,
    saveState: PropTypes.object,
    currentConfig: PropTypes.object,
    currentConfigCopy: PropTypes.object
};

/**
 STORE stuff. See store/AppStore.js
 */

export const SHOW_MODAL_CONFIRMATION_SETTINGS = 'SHOW_MODAL_CONFIRMATION_SETTINGS';
export const HIDE_MODAL_CONFIRMATION_SETTINGS = 'HIDE_MODAL_CONFIRMATION_SETTINGS';

const initialState = {
    isOpened: false,
    component: 'nowhere'
};

export const modalConfirmationSettingsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_MODAL_CONFIRMATION_SETTINGS:
            return {
                isOpened: true,
                component: action.comp
            };
        case HIDE_MODAL_CONFIRMATION_SETTINGS:
        case APP_LEAVING:
            return {
                isOpened: false
            };
        default:
            return state;
    }
};

export const modalConfirmationSettingsActions = {
    show(component) {
        return dispatch => {
            dispatch({ type: SHOW_MODAL_CONFIRMATION_SETTINGS, comp: component });
        };
    },
    hide() {
        return dispatch => {
            dispatch({ type: HIDE_MODAL_CONFIRMATION_SETTINGS });
        };
    }
};

/**
 /STORE stuff. See store/AppStore.js
 */

const mapStateToProps = state => {
    return {
        open: state.app.modal.confirmationInfo.isOpened,
        currentConfigCopy: state.app.data.configuration.configuration.currentConfigCopy,
        languageCode: state.app.data.configuration.configuration.customContentLanguageCode,
        languageList: state.app.selected.languageList,
        defaultLanguageCode: state.app.selected.defaultCode,
        hasAccessConfiguration: checkPermissions(state, ACCESS_POINTS_GROUP.CONFIGURATION),
        hasAccessConfigurationEdit: checkPermissionForLevel(
            state.oauth.accessLevel,
            ACCESS_POINTS_GROUP.CONFIGURATION,
            ACCESS_POINT_LEVEL.EDIT,
            state.oauth.userPermissionLevels,
            state.app.selected.level
        ),
        retailProductCategories: get(state, 'app.selected.retailProductCategories'),
        saveState: get(state, 'save'),
        currentConfig: get(state, 'app.data.configuration.configuration.currentConfig'),
        inContextBeta: get(state, 'app.selected.inContextBeta')
    };
};

const mapDispatchToProps = dispatch => ({
    close: () => dispatch(modalConfirmationSettingsActions.hide()),
    makeInvisibleFilters: (key, code) => dispatch({ type: MAKE_INVISIBLE_FILTERS, key, code }),
    makeVisibleFilters: (key, code) => dispatch({ type: MAKE_VISIBLE_FILTERS, key, code }),
    setConfigText: (code, value) => {
        dispatch({ type: SET_TEXT_VALUE_IN_CONFIG, code, value });
    },
    setConfigNumber: (code, value) => {
        const convertedValue = parseInt(value);
        if (isNaN(convertedValue)) {
            throw new Error('Value is not a number');
        }

        dispatch({ type: SET_NUMBER_VALUE_IN_CONFIG, code, value: convertedValue });
    },
    setCustomConfigText: (parent, code, value, side, languageCode) => {
        dispatch({
            type: SET_CUSTOM_CONTENT_TEXT_VALUE_IN_CONFIG,
            parent,
            code,
            languageCode,
            side,
            value
        });
    },
    addConfigRow: (code, path) => {
        dispatch({ type: ADD_CONFIG_ROW, code, path });
    },
    changeConfigRow: (parentCode, oldIndex, newIndex) => {
        dispatch({ type: CHANGE_CONFIG_ROW, parentCode, oldIndex, newIndex });
    },
    editConfigRow: (parentCode, editCode, index, value) => {
        dispatch({ type: EDIT_CONFIG_ROW, parentCode, editCode, index, value });
    },
    deleteConfigRow: (parentCode, index) => {
        dispatch({ type: DELETE_CONFIG_ROW, parentCode, index });
    },
    setConfigBoolean: (code, value) => {
        dispatch({ type: SET_BOOLEAN_VALUE_IN_CONFIG, code, value });
    },
    unsetConfigValue: code => {
        dispatch({ type: UNSET_VALUE_IN_CONFIG, code });
    },
    toggleConfigBoolean: (code, value) => {
        dispatch({ type: TOGGLE_BOOLEAN_VALUE_IN_CONFIG, code, value });
    },
    changeCustomContentLanguageCode: code => {
        dispatch({ type: CHANGE_CUSTOM_CONTENT_LANGUAGE_CODE, languageCode: code });
    },
    saveHotelMenuContent: menuContentByLanguages => {
        dispatch({
            code: 'hotelMenuContentByLanguages',
            type: SET_ARRAY_OR_OBJECT_IN_CONFIG,
            value: menuContentByLanguages
        });
        dispatch({ type: CHANGE_FIELDS });
    },
    setListInConfig: (code, value) => {
        dispatch({ type: SET_LIST_VALUE_IN_CONFIG, code, value });
    },
    setArrayOrObjectInConfig: (code, value) => {
        dispatch({
            type: SET_ARRAY_OR_OBJECT_IN_CONFIG,
            code,
            value
        });
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalConfirmationSettings);



// WEBPACK FOOTER //
// ./src/components/modals/ModalConfirmationSettings.js